// import React, { useState } from "react";
// import { Link } from "react-router-dom";
// import {
//   FaHome,
//   FaFileAlt,
//   FaBell,
//   FaEnvelope,
//   FaCaretDown,
//   FaCalendarAlt,
//   FaFileContract,
//   FaFileSignature,
//   FaHardHat,
//   FaClock,
//   FaImages,
//   FaPeopleCarry,
//   FaExclamationTriangle,
//   FaUsers,
//   FaSearch 
// } from "react-icons/fa";
// import { IoMenu } from "react-icons/io5";
// import "./Navbar.css";
// import { useNavigate, useLocation } from "react-router-dom";

// const Navbar = ({ onToggleSidebar }) => {
//   const [formData] = useState({ imageUrl: "" });
//   const [notifications] = useState([]);
//   const [showNotificationDropdown, setShowNotificationDropdown] =
//     useState(false);
//   const [collapsed, setCollapsed] = useState(false);
//   const [emailNotifications] = useState([]);
//   const [showEmailNotificationDropdown, setShowEmailNotificationDropdown] =
//     useState(false);
//   const [showDropdown, setShowDropdown] = useState(false);
//   const navigate = useNavigate();
//   const location = useLocation();

//   const toggleSidebar = () => {
//     setCollapsed(!collapsed);
//     onToggleSidebar(!collapsed);
//   };

//   const handleNavItemClick = () => {
//     if (window.innerWidth <= 768) {
//       setCollapsed(true);
//     }
//   };

//   const handleProfileClick = () => {
//     setShowDropdown(!showDropdown);
//   };

//   const handleLogout = () => {
//     console.log("Logged out");
//     navigate("/");
//   };

//   const toggleNotificationDropdown = () => {
//     setShowNotificationDropdown(!showNotificationDropdown);
//     setShowEmailNotificationDropdown(false);
//   };

//   const toggleEmailNotificationDropdown = () => {
//     setShowEmailNotificationDropdown(!showEmailNotificationDropdown);
//     setShowNotificationDropdown(false);
//   };

//   // Sidebar menu items data
//   const sidebarItems = [
//     { path: "/a-dashboard", icon: <FaHome />, text: "Dashboard" },
//     {
//   path: ["/a-allteams", "/addemployee", "/team-members", "/editemployee"],
//   icon: <FaPeopleCarry />,
//   text: "All Teams",
//   link: "/a-allteams"
// }
//     ,
//         { path: ["/adminleads","/leadforms"] , icon: <FaHome />, text: "Leads", },
//     //     { path: ["/customer_table", "/customer_form"], icon: <FaHome />, text: "Customers" },
//     //       {
//     //       path: ["/project-table", "/project-form", "/project/:id/view"],
//     //       icon: <FaFileContract />,
//     //       text: "Project Details",
//     //     },

    
  
//     // {
//     //   path: "/delay_tracking",
//     //   icon: <FaExclamationTriangle />,
//     //   text: "Delay Tracking & Summary",
//     // },
//     // { path: "/team_management", icon: <FaUsers />, text: "Team Management" },
//     // { path: "/gallery", icon: <FaImages />, text: "Gallery" },    { path: ["/users", "/user_new"], icon: <FaHome />, text: "Users" },
      
//   ];


//   // Function to check if current path matches any of the paths in the item
//   const isActive = (itemPath) => {
//     if (Array.isArray(itemPath)) {
//       return itemPath.some(path => {
//         if (path.includes(':id')) {
//           // Handle dynamic routes like /project/:id/view
//           const routePattern = new RegExp(path.replace(':id', '\\d+'));
//           return routePattern.test(location.pathname);
//         }
//         return location.pathname.startsWith(path);
//       });
//     }
//     return location.pathname.startsWith(itemPath);
//   };

//   return (
//     <>
//       <div className="admin-container">
//         <div className="admin-header" style={{ "--theme-color": "white" }}>
//           <div className="admin-header-left">
//             <div
//               className={`admin-sidebar-toggle ${collapsed ? "collapsed" : ""}`}
//               onClick={toggleSidebar}
//             >
//               <IoMenu className="toggle-icon" />
//             </div>{" "}
//             &nbsp;&nbsp;
      

// <div style={{ display: "flex", alignItems: "center", gap: "15px" }}>
//   <h3 className="text-center user-admin" style={{ color: "blue", margin: 0 }}>
//     Admin Site
//   </h3>

//   <div
//     style={{
//       position: "relative",
//       display: "flex",
//       alignItems: "center",
//       backgroundColor: "#f1f1f1",
//       borderRadius: "8px",
//       padding: "6px 12px",
//       width: "280px"
//     }}
//   >
//     <FaSearch
//       style={{
//         position: "absolute",
//         left: "10px",
//         color: "#888",
//         fontSize: "14px"
//       }}
//     />
//     <input
//       type="text"
//       placeholder="Search..."
//       className="admin-search-bar"
//       style={{
//         border: "none",
//         outline: "none",
//         background: "transparent",
//         paddingLeft: "24px",
//         fontSize: "14px",
//         width: "100%"
//       }}
//     />
//   </div>
// </div>


//           </div>

//           <div className="admin-header-right">
//             <div className="admin-header-icons">
//               <div
//                 className="admin-nav-icon-container"
//                 onClick={toggleNotificationDropdown}
//               >
//                 <FaBell className="admin-nav-icon" />
//                 {(notifications?.length || 0) > 0 && (
//                   <span className="admin-nav-badge">
//                     {notifications?.length || 0}
//                   </span>
//                 )}
//                 {showNotificationDropdown && (
//                   <div className="notification-dropdown">
//                     <div className="notification-dropdown-header">
//                       Notifications
//                     </div>
//                     <div className="notification-dropdown-body">
//                       {!notifications || notifications.length == 0 ? (
//                         <div className="notification-item">
//                           No new notifications
//                         </div>
//                       ) : (
//                         notifications.map((notification) => (
//                           <div
//                             key={notification.id}
//                             className="notification-item"
//                             style={{ padding: "8px", cursor: "pointer" }}
//                           >
//                             <div
//                               style={{
//                                 fontWeight: notification.read
//                                   ? "normal"
//                                   : "bold",
//                               }}
//                             >
//                               {`${notification.name || ""} ${
//                                 notification.message || ""
//                               }`.slice(0, 40)}
//                               {(notification.name?.length || 0) +
//                                 (notification.message?.length || 0) >
//                               40
//                                 ? "..."
//                                 : ""}
//                             </div>
//                             <div style={{ fontSize: "0.8em", color: "#888" }}>
//                               {new Date(notification.createdAt).toLocaleString(
//                                 "en-IN",
//                                 {
//                                   timeZone: "Asia/Kolkata",
//                                   day: "2-digit",
//                                   month: "2-digit",
//                                   year: "numeric",
//                                   hour: "2-digit",
//                                   minute: "2-digit",
//                                   second: "2-digit",
//                                   hour12: false,
//                                 }
//                               )}
//                             </div>
//                           </div>
//                         ))
//                       )}
//                     </div>
//                   </div>
//                 )}
//               </div>

//               <div
//                 className="admin-nav-icon-container"
//                 onClick={toggleEmailNotificationDropdown}
//               >
//                 <FaEnvelope className="admin-nav-icon" />
//                 {(emailNotifications?.length || 0) > 0 && (
//                   <span className="admin-nav-badge">
//                     {emailNotifications.length}
//                   </span>
//                 )}
//                 {showEmailNotificationDropdown && (
//                   <div className="notification-dropdown">
//                     <div className="notification-dropdown-header">
//                       Email Notifications
//                     </div>
//                     <div className="notification-dropdown-body">
//                       {!emailNotifications || emailNotifications.length == 0 ? (
//                         <div className="notification-item">
//                           No new email notifications
//                         </div>
//                       ) : (
//                         emailNotifications.map((emailnotification) => (
//                           <div
//                             key={emailnotification.id}
//                             className="notification-item"
//                             style={{ padding: "8px", cursor: "pointer" }}
//                           >
//                             <div
//                               style={{
//                                 fontWeight: emailnotification.read
//                                   ? "normal"
//                                   : "bold",
//                               }}
//                             >
//                               {emailnotification.text?.length > 40
//                                 ? `${emailnotification.text.slice(0, 40)}...`
//                                 : emailnotification.text}
//                             </div>
//                             <div style={{ fontSize: "0.8em", color: "#888" }}>
//                               {new Date(
//                                 emailnotification.created_at
//                               ).toLocaleString("en-IN", {
//                                 timeZone: "Asia/Kolkata",
//                                 day: "2-digit",
//                                 month: "2-digit",
//                                 year: "numeric",
//                                 hour: "2-digit",
//                                 minute: "2-digit",
//                                 second: "2-digit",
//                                 hour12: false,
//                               })}
//                             </div>
//                           </div>
//                         ))
//                       )}
//                     </div>
//                   </div>
//                 )}
//               </div>

//               <div
//                 className="admin-nav-icon-container"
//                 onClick={handleProfileClick}
//               >
//                 <div className="admin-nav-profile">
//                   {formData.imageUrl ? (
//                     <img
//                       src={formData.imageUrl}
//                       alt="Profile"
//                       className="admin-nav-profile-img"
//                     />
//                   ) : (
//                     <img
//                       src="https://i.pravatar.cc/100?img=4"
//                       alt="Default Profile"
//                       className="admin-nav-profile-img"
//                     />
//                   )}
//                   <FaCaretDown className="admin-nav-caret-icon" />
//                 </div>
//                 {showDropdown && (
//                   <div className="admin-nav-profile-dropdown">
//                     <div className="admin-nav-profile-header">
//                       <strong>customer</strong>
//                     </div>
//                     <div
//                       className="admin-nav-profile-item"
//                       onClick={() => navigate("/profile")}
//                     >
//                       Your Profile
//                     </div>
//                     <div
//                       className="admin-nav-profile-item"
//                       onClick={handleLogout}
//                     >
//                       Sign Out
//                     </div>
//                   </div>
//                 )}
//               </div>
//             </div>
//           </div>
//         </div>

//         <div
//           className={`admin-sidebar ${collapsed ? "collapsed" : ""}`}
//           style={{ "--theme-color": "white" }}
//         >
//           <div className="admin-position-sticky">
//             <ul className="nav flex-column">
//               {sidebarItems.map((item) => (
//                 <li
//                   key={
//                     Array.isArray(item.path) ? item.path.join(",") : item.path
//                   }
//                   className={`admin-nav-item ${
//                     isActive(item.path) ? "active" : ""
//                   }`}
//                 >
//                   <Link
//                     className="nav-link"
//                     to={Array.isArray(item.path) ? item.path[0] : item.path}
//                     onClick={handleNavItemClick}
//                   >
//                     {item.icon}
//                     {!collapsed && (
//                       <span className="link_text">{item.text}</span>
//                     )}
//                   </Link>
//                 </li>
//               ))}
//             </ul>
//           </div>
//         </div>
//       </div>
//     </>
//   );
// };

// export default Navbar;





// import React, { useState } from "react";
// import { Link } from "react-router-dom";
// import {
//   FaHome,
//   FaFileAlt,
//   FaBell,
//   FaEnvelope,
//   FaCaretDown,
//   FaCalendarAlt,
//   FaFileContract,
//   FaFileSignature,
//   FaHardHat,
//   FaClock,
//   FaImages,
//   FaPeopleCarry,
//   FaExclamationTriangle,
//   FaUsers,
//   FaSearch,
//   FaUserCircle
// } from "react-icons/fa";
// import { IoMenu } from "react-icons/io5";
// import { useNavigate, useLocation } from "react-router-dom";
// import "./Navbar.css";

// const Navbar = ({ onToggleSidebar }) => {
//   const [formData] = useState({ imageUrl: "" });
//   const [notifications] = useState([]);
//   const [showNotificationDropdown, setShowNotificationDropdown] = useState(false);
//   const [collapsed, setCollapsed] = useState(false);
//   const [emailNotifications] = useState([]);
//   const [showEmailNotificationDropdown, setShowEmailNotificationDropdown] = useState(false);
//   const [showDropdown, setShowDropdown] = useState(false);
//   const navigate = useNavigate();
//   const location = useLocation();

//   const toggleSidebar = () => {
//     setCollapsed(!collapsed);
//     onToggleSidebar(!collapsed);
//   };

//   const handleNavItemClick = () => {
//     if (window.innerWidth <= 768) {
//       setCollapsed(true);
//     }
//   };

//   const handleProfileClick = () => {
//     setShowDropdown(!showDropdown);
//   };

//   const handleLogout = () => {
//     console.log("Logged out");
//     navigate("/");
//   };

//   const toggleNotificationDropdown = () => {
//     setShowNotificationDropdown(!showNotificationDropdown);
//     setShowEmailNotificationDropdown(false);
//   };

//   const toggleEmailNotificationDropdown = () => {
//     setShowEmailNotificationDropdown(!showEmailNotificationDropdown);
//     setShowNotificationDropdown(false);
//   };

//   // Sidebar menu items data
//   const sidebarItems = [
//     { path: "/a-dashboard", icon: <FaHome />, text: "Dashboard" },
//     {
//       path: ["/a-allteams", "/addemployee", "/team-members", "/editemployee"],
//       icon: <FaPeopleCarry />,
//       text: "All Teams",
//       link: "/a-allteams"
//     },
//     { path: ["/adminleads","/leadforms"], icon: <FaFileAlt />, text: "Leads" },
//   ];

//   // Function to check if current path matches any of the paths in the item
//   const isActive = (itemPath) => {
//     if (Array.isArray(itemPath)) {
//       return itemPath.some(path => {
//         if (path.includes(':id')) {
//           const routePattern = new RegExp(path.replace(':id', '\\d+'));
//           return routePattern.test(location.pathname);
//         }
//         return location.pathname.startsWith(path);
//       });
//     }
//     return location.pathname.startsWith(itemPath);
//   };

//   return (
//     <>
//       <div className="admin-container">
//         <div className="admin-header">
//           <div className="admin-header-left">
//             <div
//               className={`admin-sidebar-toggle ${collapsed ? "collapsed" : ""}`}
//               onClick={toggleSidebar}
//             >
//               <IoMenu className="toggle-icon" />
//             </div>
            
//             <div className="header-brand">
//               <h3 className="admin-title">Admin Panel</h3>
//             </div>

//             <div className="search-container">
//               <FaSearch className="search-icon" />
//               <input
//                 type="text"
//                 placeholder="Search..."
//                 className="admin-search-bar"
//               />
//             </div>
//           </div>

//           <div className="admin-header-right">
//             <div className="admin-header-icons">
//               <div
//                 className="admin-nav-icon-container"
//                 onClick={toggleNotificationDropdown}
//               >
//                 <FaBell className="admin-nav-icon" />
//                 {(notifications?.length || 0) > 0 && (
//                   <span className="admin-nav-badge">
//                     {notifications?.length || 0}
//                   </span>
//                 )}
//                 {showNotificationDropdown && (
//                   <div className="notification-dropdown">
//                     <div className="notification-dropdown-header">
//                       <span>Notifications</span>
//                       <span className="notification-count">{notifications?.length || 0}</span>
//                     </div>
//                     <div className="notification-dropdown-body">
//                       {!notifications || notifications.length === 0 ? (
//                         <div className="notification-item empty">
//                           No new notifications
//                         </div>
//                       ) : (
//                         notifications.map((notification) => (
//                           <div
//                             key={notification.id}
//                             className="notification-item"
//                           >
//                             <div className="notification-content">
//                               <div className={`notification-text ${notification.read ? "" : "unread"}`}>
//                                 {`${notification.name || ""} ${
//                                   notification.message || ""
//                                 }`.slice(0, 40)}
//                                 {(notification.name?.length || 0) +
//                                   (notification.message?.length || 0) >
//                                 40
//                                   ? "..."
//                                   : ""}
//                               </div>
//                               <div className="notification-time">
//                                 {new Date(notification.createdAt).toLocaleString(
//                                   "en-IN",
//                                   {
//                                     timeZone: "Asia/Kolkata",
//                                     day: "2-digit",
//                                     month: "short",
//                                     year: "numeric",
//                                     hour: "2-digit",
//                                     minute: "2-digit",
//                                     hour12: true,
//                                   }
//                                 )}
//                               </div>
//                             </div>
//                           </div>
//                         ))
//                       )}
//                     </div>
//                     {notifications && notifications.length > 0 && (
//                       <div className="notification-dropdown-footer">
//                         Mark all as read
//                       </div>
//                     )}
//                   </div>
//                 )}
//               </div>

//               <div
//                 className="admin-nav-icon-container"
//                 onClick={toggleEmailNotificationDropdown}
//               >
//                 <FaEnvelope className="admin-nav-icon" />
//                 {(emailNotifications?.length || 0) > 0 && (
//                   <span className="admin-nav-badge">
//                     {emailNotifications.length}
//                   </span>
//                 )}
//                 {showEmailNotificationDropdown && (
//                   <div className="notification-dropdown">
//                     <div className="notification-dropdown-header">
//                       <span>Messages</span>
//                       <span className="notification-count">{emailNotifications?.length || 0}</span>
//                     </div>
//                     <div className="notification-dropdown-body">
//                       {!emailNotifications || emailNotifications.length === 0 ? (
//                         <div className="notification-item empty">
//                           No new messages
//                         </div>
//                       ) : (
//                         emailNotifications.map((emailnotification) => (
//                           <div
//                             key={emailnotification.id}
//                             className="notification-item"
//                           >
//                             <div className="notification-content">
//                               <div className={`notification-text ${emailnotification.read ? "" : "unread"}`}>
//                                 {emailnotification.text?.length > 40
//                                   ? `${emailnotification.text.slice(0, 40)}...`
//                                   : emailnotification.text}
//                               </div>
//                               <div className="notification-time">
//                                 {new Date(
//                                   emailnotification.created_at
//                                 ).toLocaleString("en-IN", {
//                                   timeZone: "Asia/Kolkata",
//                                   day: "2-digit",
//                                   month: "short",
//                                   year: "numeric",
//                                   hour: "2-digit",
//                                   minute: "2-digit",
//                                   hour12: true,
//                                 })}
//                               </div>
//                             </div>
//                           </div>
//                         ))
//                       )}
//                     </div>
//                     {emailNotifications && emailNotifications.length > 0 && (
//                       <div className="notification-dropdown-footer">
//                         View all messages
//                       </div>
//                     )}
//                   </div>
//                 )}
//               </div>

//               <div className="divider"></div>

//               <div
//                 className="admin-nav-icon-container profile-container"
//                 onClick={handleProfileClick}
//               >
//                 <div className="admin-nav-profile">
//                   {formData.imageUrl ? (
//                     <img
//                       src={formData.imageUrl}
//                       alt="Profile"
//                       className="admin-nav-profile-img"
//                     />
//                   ) : (
//                     <div className="profile-avatar">
//                       <FaUserCircle />
//                     </div>
//                   )}
//                   <div className="profile-info">
//                     <span className="profile-name">Admin User</span>
//                     <span className="profile-role">Administrator</span>
//                   </div>
//                   <FaCaretDown className="admin-nav-caret-icon" />
//                 </div>
//                 {showDropdown && (
//                   <div className="admin-nav-profile-dropdown">
//                     <div className="admin-nav-profile-header">
//                       <div className="profile-summary">
//                         <div className="profile-dropdown-avatar">
//                           <FaUserCircle />
//                         </div>
//                         <div>
//                           <strong>Admin User</strong>
//                           <p>admin@example.com</p>
//                         </div>
//                       </div>
//                     </div>
//                     <div className="dropdown-divider"></div>
//                     <div
//                       className="admin-nav-profile-item"
//                       onClick={() => navigate("/profile")}
//                     >
//                       <FaUserCircle className="dropdown-item-icon" />
//                       Your Profile
//                     </div>
//                     <div
//                       className="admin-nav-profile-item"
//                       onClick={handleLogout}
//                     >
//                       <span className="dropdown-item-icon">→</span>
//                       Sign Out
//                     </div>
//                   </div>
//                 )}
//               </div>
//             </div>
//           </div>
//         </div>

//         <div
//           className={`admin-sidebar ${collapsed ? "collapsed" : ""}`}
//         >
//           <div className="admin-position-sticky">
//             <div className="sidebar-header">
//               {!collapsed && <h3 className="sidebar-title">Navigation</h3>}
//             </div>
//             <ul className="nav flex-column">
//               {sidebarItems.map((item) => (
//                 <li
//                   key={
//                     Array.isArray(item.path) ? item.path.join(",") : item.path
//                   }
//                   className={`admin-nav-item ${
//                     isActive(item.path) ? "active" : ""
//                   }`}
//                 >
//                   <Link
//                     className="nav-link"
//                     to={Array.isArray(item.path) ? item.path[0] : item.path}
//                     onClick={handleNavItemClick}
//                   >
//                     <span className="nav-icon">{item.icon}</span>
//                     {!collapsed && (
//                       <span className="link_text">{item.text}</span>
//                     )}
//                   </Link>
//                 </li>
//               ))}
//             </ul>
//           </div>
//         </div>
//       </div>
//     </>
//   );
// };

// export default Navbar;


// import React, { useState } from "react";
// import { Link, useNavigate, useLocation } from "react-router-dom";
// import {
//   FaHome,
//   FaFileAlt,
//   FaBell,
//   FaEnvelope,
//   FaCaretDown,
//   FaUserCircle,
//   FaPeopleCarry,
//   FaSearch,
//   FaSignOutAlt,
// } from "react-icons/fa";
// import { IoMenu } from "react-icons/io5";
// import "./Navbar.css";

// const Navbar = ({ onToggleSidebar }) => {
//   const [formData] = useState({ imageUrl: "" });
//   const [notifications] = useState([]);
//   const [showNotificationDropdown, setShowNotificationDropdown] = useState(false);
//   const [collapsed, setCollapsed] = useState(false);
//   const [emailNotifications] = useState([]);
//   const [showEmailNotificationDropdown, setShowEmailNotificationDropdown] = useState(false);
//   const [showDropdown, setShowDropdown] = useState(false);
//   const navigate = useNavigate();
//   const location = useLocation();

//   const toggleSidebar = () => {
//     setCollapsed(!collapsed);
//     onToggleSidebar(!collapsed);
//   };

//   const handleNavItemClick = () => {
//     if (window.innerWidth <= 768) {
//       setCollapsed(true);
//       onToggleSidebar(true);
//     }
//   };

//   const handleProfileClick = () => {
//     setShowDropdown(!showDropdown);
//   };

//   const handleLogout = () => {
//     console.log("Logged out");
//     navigate("/");
//   };

//   const toggleNotificationDropdown = () => {
//     setShowNotificationDropdown(!showNotificationDropdown);
//     setShowEmailNotificationDropdown(false);
//   };

//   const toggleEmailNotificationDropdown = () => {
//     setShowEmailNotificationDropdown(!showEmailNotificationDropdown);
//     setShowNotificationDropdown(false);
//   };

//   const sidebarItems = [
//     { path: "/a-dashboard", icon: <FaHome />, text: "Dashboard" },
//     {
//       path: ["/a-allteams", "/addemployee", "/team-members", "/editemployee"],
//       icon: <FaPeopleCarry />, 
//       text: "All Teams",
//       link: "/a-allteams",
//     },
//     { path: ["/adminleads", "/leadforms"], icon: <FaFileAlt />, text: "Leads", link: "/adminleads" },
//   ];

//   const isActive = (itemPath) => {
//     if (Array.isArray(itemPath)) {
//       return itemPath.some((path) => {
//         if (path.includes(":id")) {
//           const routePattern = new RegExp(path.replace(":id", "\\d+"));
//           return routePattern.test(location.pathname);
//         }
//         return location.pathname.startsWith(path);
//       });
//     }
//     return location.pathname.startsWith(itemPath);
//   };

//   return (
//     <div className="admin-container">
//       <div className="admin-header">
//         <div className="admin-header-left">
//           <div
//             className={`admin-sidebar-toggle ${collapsed ? "collapsed" : ""}`}
//             onClick={toggleSidebar}
//           >
//             <IoMenu className="toggle-icon" />
//           </div>
//           <div className="header-brand">
//             <h3 className="admin-title">Admin Panel</h3>
//           </div>
//           {/* <div className="search-container">
//             <FaSearch className="search-icon" />
//             <input
//               type="text"
//               placeholder="Search..."
//               className="admin-search-bar"
//             />
//           </div> */}
//         </div>
//         <div className="admin-header-right">
//           <div className="admin-header-icons">
//             <div
//               className="admin-nav-icon-container"
//               onClick={toggleNotificationDropdown}
//             >
//               <FaBell className="admin-nav-icon" />
//               {notifications?.length > 0 && (
//                 <span className="admin-nav-badge">{notifications.length}</span>
//               )}
//               {showNotificationDropdown && (
//                 <div className="notification-dropdown">
//                   <div className="notification-dropdown-header">
//                     <span>Notifications</span>
//                     <span className="notification-count">{notifications?.length || 0}</span>
//                   </div>
//                   <div className="notification-dropdown-body">
//                     {!notifications || notifications.length === 0 ? (
//                       <div className="notification-item empty">
//                         No new notifications
//                       </div>
//                     ) : (
//                       notifications.map((notification) => (
//                         <div
//                           key={notification.id}
//                           className="notification-item"
//                         >
//                           <div className="notification-content">
//                             <div className={`notification-text ${notification.read ? "" : "unread"}`}>
//                               {`${notification.name || ""} ${notification.message || ""}`.slice(0, 40)}
//                               {(notification.name?.length || 0) + (notification.message?.length || 0) > 40 ? "..." : ""}
//                             </div>
//                             <div className="notification-time">
//                               {new Date(notification.createdAt).toLocaleString(
//                                 "en-IN",
//                                 {
//                                   timeZone: "Asia/Kolkata",
//                                   day: "2-digit",
//                                   month: "short",
//                                   year: "numeric",
//                                   hour: "2-digit",
//                                   minute: "2-digit",
//                                   hour12: true,
//                                 }
//                               )}
//                             </div>
//                           </div>
//                         </div>
//                       ))
//                     )}
//                   </div>
//                   {notifications?.length > 0 && (
//                     <div className="notification-dropdown-footer">
//                       Mark all as read
//                     </div>
//                   )}
//                 </div>
//               )}
//             </div>
//             <div
//               className="admin-nav-icon-container"
//               onClick={toggleEmailNotificationDropdown}
//             >
//               <FaEnvelope className="admin-nav-icon" />
//               {emailNotifications?.length > 0 && (
//                 <span className="admin-nav-badge">{emailNotifications.length}</span>
//               )}
//               {showEmailNotificationDropdown && (
//                 <div className="notification-dropdown">
//                   <div className="notification-dropdown-header">
//                     <span>Messages</span>
//                     <span className="notification-count">{emailNotifications?.length || 0}</span>
//                   </div>
//                   <div className="notification-dropdown-body">
//                     {!emailNotifications || emailNotifications.length === 0 ? (
//                       <div className="notification-item empty">
//                         No new messages
//                       </div>
//                     ) : (
//                       emailNotifications.map((emailnotification) => (
//                         <div
//                           key={emailnotification.id}
//                           className="notification-item"
//                         >
//                           <div className="notification-content">
//                             <div className={`notification-text ${emailnotification.read ? "" : "unread"}`}>
//                               {emailnotification.text?.length > 40
//                                 ? `${emailnotification.text.slice(0, 40)}...`
//                                 : emailnotification.text}
//                             </div>
//                             <div className="notification-time">
//                               {new Date(emailnotification.created_at).toLocaleString(
//                                 "en-IN",
//                                 {
//                                   timeZone: "Asia/Kolkata",
//                                   day: "2-digit",
//                                   month: "short",
//                                   year: "numeric",
//                                   hour: "2-digit",
//                                   minute: "2-digit",
//                                   hour12: true,
//                                 }
//                               )}
//                             </div>
//                           </div>
//                         </div>
//                       ))
//                     )}
//                   </div>
//                   {emailNotifications?.length > 0 && (
//                     <div className="notification-dropdown-footer">
//                       View all messages
//                     </div>
//                   )}
//                 </div>
//               )}
//             </div>
//             <div className="divider"></div>
//             <div
//               className="admin-nav-icon-container profile-container"
//               onClick={handleProfileClick}
//             >
//               <div className="admin-nav-profile">
//                 {formData.imageUrl ? (
//                   <img
//                     src={formData.imageUrl}
//                     alt="Profile"
//                     className="admin-nav-profile-img"
//                   />
//                 ) : (
//                   <div className="profile-avatar">
//                     <FaUserCircle />
//                   </div>
//                 )}
//                 <div className="profile-info">
//                   <span className="profile-name">Admin User</span>
//                   <span className="profile-role">Administrator</span>
//                 </div>
//                 <FaCaretDown className="admin-nav-caret-icon" />
//               </div>
//               {showDropdown && (
//                 <div className="admin-nav-profile-dropdown">
//                   <div className="admin-nav-profile-header">
//                     <div className="profile-summary">
//                       <div className="profile-dropdown-avatar">
//                         <FaUserCircle />
//                       </div>
//                       <div>
//                         <strong>Admin User</strong>
//                         <p>admin@example.com</p>
//                       </div>
//                     </div>
//                   </div>
//                   <div className="dropdown-divider"></div>
//                   <div
//                     className="admin-nav-profile-item"
//                     onClick={() => navigate("/profile")}
//                   >
//                     <FaUserCircle className="dropdown-item-icon" />
//                     Your Profile
//                   </div>
//                   <div
//                     className="admin-nav-profile-item"
//                     onClick={handleLogout}
//                   >
//                     <FaSignOutAlt className="dropdown-item-icon" />
//                     Sign Out
//                   </div>
//                 </div>
//               )}
//             </div>
//           </div>
//         </div>
//       </div>
//       <div className={`admin-sidebar ${collapsed ? "collapsed" : ""}`}>
//         <div className="admin-position-sticky">
//           <div className="sidebar-header">
//             {!collapsed && <h3 className="sidebar-title">Navigation</h3>}
//           </div>
//           <ul className="nav flex-column">
//             {sidebarItems.map((item) => (
//               <li
//                 key={Array.isArray(item.path) ? item.path.join(",") : item.path}
//                 className={`admin-nav-item ${isActive(item.path) ? "active" : ""}`}
//               >
//                 <Link
//                   className="nav-link"
//                   to={item.link || item.path}
//                   onClick={handleNavItemClick}
//                 >
//                   <span className="nav-icon">{item.icon}</span>
//                   {!collapsed && <span className="link_text">{item.text}</span>}
//                 </Link>
//               </li>
//             ))}
//           </ul>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default Navbar;



import React, { useState ,useContext } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import {
  FaHome,
  FaFileAlt,
  FaBell,
  FaEnvelope,
  FaCaretDown,
  FaUserCircle,
  FaPeopleCarry,
  FaSearch,
  FaSignOutAlt,
  FaQuoteLeft ,
   FaBuilding 
} from "react-icons/fa";
import { IoMenu } from "react-icons/io5";
import "./Navbar.css";
import { AuthContext } from "../../AuthContext/Authcontext"; // IMPORT AuthContext


// Import your logo (replace with your actual logo path)
import logo from "../../images/Final-logo-SBS.png";

const Navbar = ({ onToggleSidebar }) => {
  const [formData] = useState({ imageUrl: "" });
  const [notifications] = useState([]);
  const [showNotificationDropdown, setShowNotificationDropdown] = useState(false);
  const [collapsed, setCollapsed] = useState(false);
  const [emailNotifications] = useState([]);
  const [showEmailNotificationDropdown, setShowEmailNotificationDropdown] = useState(false);
  const [showDropdown, setShowDropdown] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
    const { userName, userEmail, logout } = useContext(AuthContext); // USE AuthContext


  const toggleSidebar = () => {
    setCollapsed(!collapsed);
    onToggleSidebar(!collapsed);
  };

  const handleNavItemClick = () => {
    if (window.innerWidth <= 768) {
      setCollapsed(true);
      onToggleSidebar(true);
    }
  };

  const handleProfileClick = () => {
    setShowDropdown(!showDropdown);
  };

  const handleLogout = () => {
    console.log("Logged out");
    navigate("/");
  };

  const toggleNotificationDropdown = () => {
    setShowNotificationDropdown(!showNotificationDropdown);
    setShowEmailNotificationDropdown(false);
  };

  const toggleEmailNotificationDropdown = () => {
    setShowEmailNotificationDropdown(!showEmailNotificationDropdown);
    setShowNotificationDropdown(false);
  };

  const sidebarItems = [
    { path: "/a-dashboard", icon: <FaHome />, text: "Dashboard" },
    {
      path: ["/a-allteams", "/addemployee", "/team-members", "/editemployee"],
      icon: <FaPeopleCarry />, 
      text: "All Teams",
      link: "/a-allteams",
    },
    { path: ["/adminleads", "/leadforms","/a-newviewlead","/a-comments","/a-followup","/send-budget","/a-add-lead","/lead_view"], icon: <FaFileAlt />, text: "Leads", link: "/adminleads" },
    { path: ["/adminoppleads","/view-lead","/a-opp-comments", "/a-opp-followup","/raw-mail","/view-sent-quotations","/view-quotation", "/opportunity_view","/regret-email/","/a-send-email/"], icon: <FaFileAlt />, text: "Opportunity", link: "/adminoppleads" },
{ 
  path: ["/quotationpage", "/previewquotation","/a-opp-view-sent-quotations"], 
  icon: <FaQuoteLeft />, 
  text: "Quotation", 
  link: "/quotationpage" 
},
  ];

  const isActive = (itemPath) => {
    if (Array.isArray(itemPath)) {
      return itemPath.some((path) => {
        if (path.includes(":id")) {
          const routePattern = new RegExp(path.replace(":id", "\\d+"));
          return routePattern.test(location.pathname);
        }
        return location.pathname.startsWith(path);
      });
    }
    return location.pathname.startsWith(itemPath);
  };

  return (
    <div className="admin-container">
      <div className="admin-header">
        <div className="admin-header-left">
          <div
            className={`admin-sidebar-toggle ${collapsed ? "collapsed" : ""}`}
            onClick={toggleSidebar}
          >
            <IoMenu className="toggle-icon" />
          </div>
          {/* Logo added here */}
          <div className="header-logo">
            <img src={logo} alt="Company Logo" className="logo-image" />
          </div>
          {/* <div className="search-container">
            <FaSearch className="search-icon" />
            <input
              type="text"
              placeholder="Search..."
              className="admin-search-bar"
            />
          </div> */}
        </div>
        {/* Centered Admin Panel title */}
        <div className="admin-header-center">
          <h3 className="admin-title">Admin Panel</h3>
        </div>
        <div className="admin-header-right">
          <div className="admin-header-icons">
            <div
              className="admin-nav-icon-container"
              onClick={toggleNotificationDropdown}
            >
              <FaBell className="admin-nav-icon" />
              {notifications?.length > 0 && (
                <span className="admin-nav-badge">{notifications.length}</span>
              )}
              {showNotificationDropdown && (
                <div className="notification-dropdown">
                  <div className="notification-dropdown-header">
                    <span>Notifications</span>
                    <span className="notification-count">{notifications?.length || 0}</span>
                  </div>
                  <div className="notification-dropdown-body">
                    {!notifications || notifications.length === 0 ? (
                      <div className="notification-item empty">
                        No new notifications
                      </div>
                    ) : (
                      notifications.map((notification) => (
                        <div
                          key={notification.id}
                          className="notification-item"
                        >
                          <div className="notification-content">
                            <div className={`notification-text ${notification.read ? "" : "unread"}`}>
                              {`${notification.name || ""} ${notification.message || ""}`.slice(0, 40)}
                              {(notification.name?.length || 0) + (notification.message?.length || 0) > 40 ? "..." : ""}
                            </div>
                            <div className="notification-time">
                              {new Date(notification.createdAt).toLocaleString(
                                "en-IN",
                                {
                                  timeZone: "Asia/Kolkata",
                                  day: "2-digit",
                                  month: "short",
                                  year: "numeric",
                                  hour: "2-digit",
                                  minute: "2-digit",
                                  hour12: true,
                                }
                              )}
                            </div>
                          </div>
                        </div>
                      ))
                    )}
                  </div>
                  {notifications?.length > 0 && (
                    <div className="notification-dropdown-footer">
                      Mark all as read
                    </div>
                  )}
                </div>
              )}
            </div>
            <div
              className="admin-nav-icon-container"
              onClick={toggleEmailNotificationDropdown}
            >
              <FaEnvelope className="admin-nav-icon" />
              {emailNotifications?.length > 0 && (
                <span className="admin-nav-badge">{emailNotifications.length}</span>
              )}
              {showEmailNotificationDropdown && (
                <div className="notification-dropdown">
                  <div className="notification-dropdown-header">
                    <span>Messages</span>
                    <span className="notification-count">{emailNotifications?.length || 0}</span>
                  </div>
                  <div className="notification-dropdown-body">
                    {!emailNotifications || emailNotifications.length === 0 ? (
                      <div className="notification-item empty">
                        No new messages
                      </div>
                    ) : (
                      emailNotifications.map((emailnotification) => (
                        <div
                          key={emailnotification.id}
                          className="notification-item"
                        >
                          <div className="notification-content">
                            <div className={`notification-text ${emailnotification.read ? "" : "unread"}`}>
                              {emailnotification.text?.length > 40
                                ? `${emailnotification.text.slice(0, 40)}...`
                                : emailnotification.text}
                            </div>
                            <div className="notification-time">
                              {new Date(emailnotification.created_at).toLocaleString(
                                "en-IN",
                                {
                                  timeZone: "Asia/Kolkata",
                                  day: "2-digit",
                                  month: "short",
                                  year: "numeric",
                                  hour: "2-digit",
                                  minute: "2-digit",
                                  hour12: true,
                                }
                              )}
                            </div>
                          </div>
                        </div>
                      ))
                    )}
                  </div>
                  {emailNotifications?.length > 0 && (
                    <div className="notification-dropdown-footer">
                      View all messages
                    </div>
                  )}
                </div>
              )}
            </div>
            <div className="divider"></div>
            <div
              className="admin-nav-icon-container profile-container"
              onClick={handleProfileClick}
            >
              <div className="admin-nav-profile">
                {formData.imageUrl ? (
                  <img
                    src={formData.imageUrl}
                    alt="Profile"
                    className="admin-nav-profile-img"
                  />
                ) : (
                  <div className="profile-avatar">
                    <FaUserCircle />
                  </div>
                )}
              <div className="profile-info">
                  <span className="profile-name">{userName || "Admin User"}</span>
                  <span className="profile-role">{userEmail || "admin@example.com"}</span>
                </div>
                <FaCaretDown className="admin-nav-caret-icon" />
              </div>
              {showDropdown && (
                <div className="admin-nav-profile-dropdown">
                  <div className="admin-nav-profile-header">
                    <div className="profile-summary">
                      <div className="profile-dropdown-avatar">
                        <FaUserCircle />
                      </div>
                      <div>
                        <strong>{userName || "Admin User"}</strong>
                        <p>{userEmail || "admin@example.com"}</p>
                      </div>
                    </div>
                  </div>
                  <div className="dropdown-divider"></div>
                  {/* <div
                    className="admin-nav-profile-item"
                    onClick={() => navigate("/profile")}
                  >
                    <FaUserCircle className="dropdown-item-icon" />
                    Your Profile
                  </div> */}

                    <div
                    className="admin-nav-company-item"
                    onClick={() => navigate("/company")}
                  >
                     <FaBuilding className="dropdown-item-icon" />
                     company
                  </div>
                  <div
                    className="admin-nav-company-item"
                    onClick={handleLogout}
                  >
                    <FaSignOutAlt className="dropdown-item-icon" />
                    Sign Out
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
      <div className={`admin-sidebar ${collapsed ? "collapsed" : ""}`}>
        <div className="admin-position-sticky">
          {/* <div className="sidebar-header">
            {!collapsed && <h3 className="sidebar-title">Admin Panel</h3>}
          </div> */}
          <ul className="nav flex-column">
            {sidebarItems.map((item) => (
              <li
                key={Array.isArray(item.path) ? item.path.join(",") : item.path}
                className={`admin-nav-item ${isActive(item.path) ? "active" : ""}`}
              >
                <Link
                  className="nav-link"
                  to={item.link || item.path}
                  onClick={handleNavItemClick}
                >
                  <span className="nav-icon">{item.icon}</span>
                  {!collapsed && <span className="link_text">{item.text}</span>}
                </Link>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </div>
  );
};

export default Navbar;